/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  var amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    // Check if premium-attachment-kit block is present (handles free gifts separately)
    var hasPremiumKit = document.querySelector('.premium-attachment-kit') !== null;
    
    if (hasPremiumKit) {
      return;
    }
    
    /*GB! free product added STARTS*/
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) {
        } else {
          $(".gb-free-product-trigger").trigger("click");
        }
      } else {
        $(".gb-remove-product").trigger("click");
      }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {
        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {
          } else {
            $(".gb-free-product-trigger").trigger("click");
          }
        } else {
          $(".gb-remove-product").trigger("click");
        }
      }, 3000);
    });

    // $("body").on("click", ".shop-add-to-cart-button", function () {
    //   setTimeout(function () {
    //     var cart_total = $(".gb-totals-total-value").first().text();
    //     if (cart_total >= amount_free_product) {
    //       if ($(".cart-item").hasClass("gb-find-remove-product")) {
    //       } else {
    //         $(".gb-free-product-trigger").trigger("click");
    //       }
    //     } else {
    //       $(".gb-remove-product").trigger("click");
    //     }
    //   }, 3000);
    // });
  }

  $("body").on("click", ".gb-shipping-protection-button label.switch", function(e) {
    if (e.target.tagName == "INPUT") return;
    var curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    var curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    var spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    var checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    var wasChecked = curElem.classList.contains("checked");

    if (!wasChecked) {
      if (spinAnim.style.display == "block" || curInputElem.checked) return;

      // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
      var form = document.querySelector("form.shipping-protection-form");

      var formData = new FormData(form);
      if (!formData.get("id")) {
        console.log("There is no shipping protection product selected. Please select the shipping product in the global theme settings");
        return;
      }

      spinAnim.style.display = "block";

      fetch(routes.cart_add_url, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function(response) {
        if (response.ok) {
          spinAnim.style.display = "none";
          checkElem.style.display = "block";
        }
      }).catch(function(err) {
        // Handle error
      });
      
      fetch(routes.cart_url + "?view=drawer")
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var cartDrawer = document.querySelector("#CartDrawer");
          var parsedCartHtml = parser.parseFromString(html, "text/html");
          var newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, function() {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch(function(_err) {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      var cartDrawer = document.querySelector("#CartDrawer");
      var removeButton = cartDrawer.querySelector('cart-remove-button[data-id="' + shippingProductId + '"]');
      var shippingItemIndex = removeButton ? removeButton.dataset.index : null;

      var removeCallback = function() {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      var cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems && cartItems.updateQuantity) {
        var event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(function() { return fetch(routes.cart_url + "?view=drawer"); })
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var cartDrawer = document.querySelector("#CartDrawer");
            var parsedCartHtml = parser.parseFromString(html, "text/html");
            var newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(function() {
            removeCallback();
          });
      }
    }
  });

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      return;
    }
    $(this).closest(".gb-get-main-freq-pro").find(".product-variant-id").val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    var parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      return;
    }

    var allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map(function(sel) { return sel.value; })
      .join(" / ");

    var variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      return;
    }

    var matchedOption = Array.from(variantSelect.options).find(function(option) { return option.text.includes(allValues); });

    var idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      return;
    }

    if (matchedOption) {
      idInput.value = matchedOption.value;
    } else {
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    var idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on("click change input", function () {
    var cartItem = $(this).closest(".cart-item");
    var variantId = $(this).closest(".quantity-input").find(".quantity__input").data("quantity-variant-id");

    // If this is a form submission, ensure the ID is included
    if ($(this).closest("form").length > 0) {
      var idInput = $(this).closest("form").find('input[name="id"]');
      if (idInput.length === 0 && variantId) {
        $("<input>")
          .attr({
            type: "hidden",
            name: "id",
            value: variantId,
          })
          .appendTo($(this).closest("form"));
      } else if (idInput.length > 0 && variantId) {
        idInput.val(variantId);
      }
    }
  });

  // Add validation for cart drawer checkout button
  $("#CartDrawer-Checkout").on("click", function (e) {
    var form = $("#CartDrawer-Form");
    if (form.length === 0) return;

    // Check if there are any items in the cart
    var cartItems = form.find(".cart-item");
    if (cartItems.length === 0) {
      e.preventDefault();
      return false;
    }

  });

  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form",
  ).on("click", function (e) {
    var parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      return;
    }

    // Find the product ID input or data attribute
    var productId = null;

    // Check for direct ID input
    var idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      var selectedOption = parentBlock.find(".gb-change-variant_id option:selected");
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }


    if (this.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;

    // If no product ID found, prevent submission
    if (!productId) {
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    var quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});
